import { NgModule } from '@angular/core';

import { ImagePreviewComponent } from './image-preview.component';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { IconModule } from 'src/app/components/icon/icon.module';
import { NgxViewerModule } from '../ngx-viewer/ngx-viewer.module';

@NgModule({
  declarations: [ImagePreviewComponent],
  imports: [CommonModule, SharedModule, IconModule, NgxViewerModule],
  exports: [ImagePreviewComponent],
})
export class ImagePreviewModule {}
